/** Bump these when the legal documents change to force re-acceptance on next sign-in. */
export const TERMS_VERSION = "2026-08-12";
export const PRIVACY_VERSION = "2026-08-07";
/**
 * The Professional Advice Disclaimer is published as part of the Terms of
 * Service, so it carries the same version identifier.
 */
export const DISCLAIMER_VERSION = TERMS_VERSION;
